window.nostoAutoSearch = window.nostoAutoSearch || {};
(function () {
    'use strict';
    nostoAutoSearch.resultTermFromNosto = function (predictiveSearchResults, searchTerm, type = 'query', viewButton = null, defaultPredictiveSearch = null) {
        let self = this;
        (async () => {
            while (!window.hasOwnProperty('nostojs')) {
                await new Promise(resolve => setTimeout(resolve, 1000));
            }

            let endPoint = 'https://search.nosto.com/v1/graphql',
                token = theme.nosto_credentials.access_token,
                accountId = theme.nosto_credentials.account_id;
            fetch(endPoint, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: `query {
                          search(
                            accountId: "${accountId}"
                            query: "${searchTerm}"
                            products: {
                              size: 10
                            }
                          ) {
                            products {
                              hits {
                                productId
                                url
                                name
                                imageUrl
                                brand
                                availability
                                price
                                listPrice
                                priceCurrencyCode
                                customFields {
                                  key
                                  value
                                }
                                skus {
                                  name
                                  imageUrl
                                  id
                                  price
                                  customFields {
                                    key
                                    value
                                  }
                                }
                              }
                              facets {
                                ... on SearchTermsFacet {
                                  id
                                  field
                                  type
                                  name
                                  data {
                                    value
                                    count
                                    selected
                                  }
                                }
                                ... on SearchStatsFacet {
                                  id
                                  field
                                  type
                                  name
                                  min
                                  max
                                }
                              }
                              total
                              size
                              from
                              fuzzy
                            }
                          }
                        }`
                }),
            }).then((res) => res.json())
                .then((result) => {
                    let response = result.data.search;
                    response.query = searchTerm;
                    if (defaultPredictiveSearch.parentNode.querySelector('input[type="search"]').value != response.query) {
                        // console.log('response.query', response.query)
                        return;
                    }
                    if (response.products && response.products.hits.length > 0) {
                        let resultDefault = predictiveSearchResults.querySelector('.results__group-2'),
                            htmlShow = formatNostoHtml(response, viewButton),
                            searchWrapper = predictiveSearchResults.querySelector('#predictive-search-results');

                        if (resultDefault) {
                            resultDefault.innerHTML = htmlShow;
                        } else {
                            if (searchWrapper && searchWrapper.querySelector('.predictive-search__no-results')) {
                                searchWrapper.querySelector('.results').remove();
                            }
                            searchWrapper.innerHTML += htmlShow;
                        }

                        insertBrands(response.products.facets, predictiveSearchResults);
                    }

                    predictiveSearchResults.style.display = 'block';

                    if (defaultPredictiveSearch) {
                        defaultPredictiveSearch.innerHTML = predictiveSearchResults.innerHTML;
                        defaultPredictiveSearch.style.display = 'block';
                    }
                    // open();

                    let nostoTagSearchHtml = `<div class="nosto_search_term" style="display:none">search.termss</div>`;
                    document.querySelector('body').insertAdjacentHTML('beforeend', nostoTagSearchHtml);

                    nostojs(api => {
                        api.recordSearch(
                            "autocomplete",
                            {
                                query: response.query
                            },
                            {
                                products: response.products
                            }, 
                            {
                                isKeyword: false
                            }
                        )
                    })
                    // trigger product click
                    let productElements = document.querySelectorAll('.search-nosto-product-item');

                    productElements.forEach(el => el.addEventListener('click', e => {
                        nostojs(api => {
                            api.recordSearchClick(
                                "autocomplete",
                                {
                                    productId: e.currentTarget.getAttribute('product-nosto-id'),
                                    url: e.currentTarget.getAttribute('href')
                                }
                            )
                        })
                    }));
                });
        })();
        //  end fetch

        function insertBrands(data, predictiveSearchResults) {
            let html = ``,
                max_item = theme.autocomplete_settings.brand_limit_display,
                total = 0;

            for (const facet of data) {
                if (facet.field === 'brand') {
                    facet.data.forEach((d) => {
                        if (max_item && total >= max_item) {
                            return;
                        }
                        html += `
                      <li role="option" class="r-item">
                        <a href="${renderBrandUrl(d.value)}">
                          <span>${d.value}</span>
                        </a>
                      </li>
                      `;
                        total++;
                    });
                }
            }

            if (html && predictiveSearchResults.querySelector('.results__group-1')) {
                if (predictiveSearchResults.querySelector('.results__group-1')) {
                    predictiveSearchResults.querySelector('.predictive-search-brands').innerHTML = html;
                    predictiveSearchResults.querySelector('.results--brands').style.display = 'block';
                }
            }

            return html;
        }

        function renderBrandUrl(brand) {
            return window.location.origin + '/collections/' + brand.replace(' ', "-").replace('.', '').toLowerCase();
        }

        function formatNostoHtml(data, viewButton = null) {
            let resultGroupProduct = predictiveSearchResults.querySelector('.results__group-2'),
                rate = Shopify.currency.rate,
                currencyCode = Shopify.currency.active,
                queryText = data.query;
            let titleH2 = `${data.products.total} Products found Related to “${queryText}”`;
            if (!viewButton) {
                viewButton = `<button class="results__search-btn nosto-view-more btn btn--full desktop">${theme.strings.searchViewMore}</button>`;
            }

            if (viewButton === 'disabled') {
                titleH2 = 'Popular Products';
            }

            var html = `
        <div class="results results--products">
            <div class="s-product-list-top"> <h2 class="h2" id="predictive-search-products">${titleH2}</h2>`
            if (viewButton !== 'disabled') {
                html += `${viewButton}`;
            }
            html += `</div>
            <ul role="listbox" class="r-listbox" aria-labelledby="predictive-search-products">`;
            data.products.hits.forEach(function (product, index) {
                if (index > 4) {
                    return;
                }
                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: currencyCode,
                    currencyDisplay: 'narrowSymbol'
                });
                let nostoPrice = product.price,
                    variantData = matchVariantsData(product, queryText),
                    finalPrice = variantData.price * rate;

                let hidePrice = false;
                if (product.customFields) {
                   product.customFields.forEach((item) => {
                      if (item.key === 'custom-show_product_price' && item.value === 'true') {
                          hidePrice = true;
                      }
                   })
                }
                let priceRender = hidePrice ? '' : formatter.format(finalPrice);
                if (product.skus) {
                     let basePrice = product.price,
                          showPriceFrom = false;
                     product.skus.forEach(item=> {
                       if(item.price !== basePrice) showPriceFrom = true;
                       if(item.price < basePrice) basePrice = item.price
                     })

                     if (showPriceFrom) {
                        priceRender = 'from ' + formatter.format(Number(basePrice) * rate);
                     }
                }
                html += `<li role="option" class="r-item">
                  <a href="${variantData.url}" class="search-nosto-product-item" product-nosto-id="${product.productId}">
                    <div class="results-products__image grid__image-ratio">
                        <img src="${variantData.imageUrl}" alt="${product.name}">
                    </div>
                    <div class="results-products__info">
                      <span class="grid-product__vendor">${product.brand}</span>
                      <span>${product.name}</span>
                      <span class="grid-product__price">${priceRender}</span>
                    </div>
                  </a>
                </li>`;
            });

            html += `</ul><button class="results__search-btn nosto-view-more btn btn--full mobile">${theme.strings.searchViewMore}</button></div>`;

            if (!resultGroupProduct) {
                html = '<div class="results__group-2">' + html + '</div>';
            }

            return html;
        }

        // get variant data if match with query text search
        function matchVariantsData(product, queryText) {
            let variantData = {};
            if (product.skus) {
                product.skus.forEach(function (sku, index) {
                    let listText = queryText.split(' ');
                    let skuMapped = false;
                    if (listText.length > 0) {
                        listText.forEach(function (sWord) {
                            if (sku.name && sku.name.toLowerCase().includes(sWord.toLowerCase())) {
                                skuMapped = true;
                            }
                        })
                    }

                    if (skuMapped) {
                        if (product.url.indexOf('?') > -1) {
                            variantData.url = product.url.replace(/\/$/, '') + '&variant=' + sku.id;
                        } else {
                            variantData.url = product.url + '?variant=' + sku.id
                        }

                        variantData.imageUrl = sku.imageUrl;
                        variantData.price = sku.price;
                    }
                })
            }

            if (variantData.url) {
                let imageUrl = variantData.imageUrl ? variantData.imageUrl : product.imageUrl;
                return {
                    'url': variantData.url,
                    'imageUrl': imageUrl,
                    'price': variantData.price
                };
            }

            return {
                'url': product.url,
                'imageUrl': product.imageUrl,
                'price': product.price
            }
        }

        function getImageUrl(product, queryText) {
            let childImage = ''
            if (product.skus) {
                product.skus.forEach(function (sku, index) {
                    let listText = queryText.split(' ');
                    let skuMapped = false;
                    if (listText.length > 0) {
                        listText.forEach(function (sWord) {
                            if (sku.name && sku.name.toLowerCase().includes(sWord.toLowerCase())) {
                                skuMapped = true;
                            }
                        })
                    }

                    if (skuMapped) {
                        childImage = sku.imageUrl
                    }
                })
            }

            if (childImage) {
                return childImage;
            }

            return product.imageUrl
        }

        function recordProductClickNosto(e) {
            console.log('hifoewlhgreklgjrklegre');
            e.preventDefault()
        }
    }

    nostoAutoSearch.initDefaultSearch = function (input, predictiveSearchResults) {
        var self = this;
        if (!input.value) {
            let configs = theme.autocomplete_settings,
                suggestionsC = configs.suggestions,
                collectionsC = configs.collections,
                pagesC = configs.pages,
                articlesC = configs.articles,
                productsC = configs.products;

            let html = `<div class="predictive-search-results" id="predictive-search-results">`;

            if (suggestionsC) {
                let suggestionsData = suggestionsC.split(",");
                html += `
           <div class="results__suggestion">
              <div class="results results--queries">
                <h3 class="h4" id="predictive-search-suggestions">Popular Search Terms
                </h3>
                <ul role="listbox" class="r-listbox" aria-labelledby="predictive-search-queries">`;
                suggestionsData.forEach(function (data) {
                    html += `
                         <li role="option" class="r-item">
                          <a href="${buildUrlItemSearch('suggestion', data)}">
                            <span>${data}</span>
                          </a>
                        </li>
                      `
                });
                html += `</ul>
              </div>
              <p class="seperate-line"></p>
            </div>`;
            }

            // render result1;
            if (true) {
                html += `<div class="results__group-1">`;

                if (Object.keys(collectionsC).length) {
                    html += `
              <div class="results results--collections">
               <h3 class="h4" id="predictive-search-collections">Collections</h3>
                <ul role="listbox" class="r-listbox" aria-labelledby="predictive-search-collections">`;
                    for (const col in collectionsC) {
                        html += `
                    <li role="option" class="r-item">
                      <a href="${buildUrlItemSearch('collection', collectionsC[col].url)}">
                        <span>${collectionsC[col].label}</span>
                      </a>
                    </li>
                    `;
                    }

                    html += ` </ul>
              </div>
             `;
                }

                html += `
                <div class="results results--brands">
                   <h3 class="h4" id="predictive-search-brands">
                     Brands
                   </h3>
                   <ul role="listbox" class="predictive-search-brands r-listbox" aria-labelledby="predictive-search-brands">
                   </ul>
                </div>
             `;

                if (Object.keys(articlesC).length) {

                    html += `<div class="results results--articles">
               <h3 class="h4" id="predictive-search-articles">Articles</h3>
               <ul role="listbox" class="r-listbox" aria-labelledby="predictive-search-articles">`;
                    for (const ar in articlesC) {
                        html += `
                     <li role="option" class="r-item" >
                      <a href="${buildUrlItemSearch('article', articlesC[ar].url)}">
                        <span>${articlesC[ar].label}</span>
                      </a>
                    </li>
                 `;
                    }
                    html += `</ul>
             </div>`;
                }

                if (Object.keys(pagesC).length) {
                    html += `
              <div class="results results--pages">
                <h3 class="h4" id="predictive-search-pages">Pages</h3>
                 <ul role="listbox" class="r-listbox" aria-labelledby="predictive-search-pages">`;
                    for (const pg in pagesC) {
                        html += `
                             <li role="option" class="r-item" >
                              <a href="${buildUrlItemSearch('page', pagesC[pg].url)}">
                                <span>${pagesC[pg].label}</span>
                              </a>
                            </li>
                         `;
                    }
                    html += `</ul>
              </div>
             `;
                }

                html += `</div>`;
            }

            // render result2 (products)
            html += `<div class="results__group-2"></div>`;

            html += `</div>`;

            predictiveSearchResults.innerHTML = html;

            initDefaultRecommendation();
            if (false) {
                // currently disabled
                let typeSearch = 'query',
                    viewButton = '',
                    viewAllUrl = buildUrlItemSearch('suggestion', productsC.query);

                if (productsC.type === 'by_collection_name') {
                    typeSearch = 'collection';
                    viewAllUrl = window.location.origin + '/collections/' + productsC.query.replaceAll(' ', '-').toLowerCase();
                }
                viewButton = 'disabled';
                nostoAutoSearch.resultTermFromNosto(predictiveSearchResults, productsC.query, typeSearch, viewButton);
            }

            predictiveSearchResults.style.display = 'block';
        }

        function buildUrlItemSearch(type, key) {
            if (type === 'suggestion') {
                return window.location.origin + "/search?q=" + key.replaceAll(' ', '+');
            }
            if (type === 'article' || type === 'collection' || type === 'page') {
                return window.location.origin + key;
            }

            return '';
        }


        function initDefaultRecommendation() {
            (async () => {
                while (!window.hasOwnProperty('nostojs')) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                }

                nostojs(api => {
                    api.createRecommendationRequest({})
                        .setElements(["search-dropdown-nosto-1"])
                        .load()
                        .then(response => {
                            renderRecommendationProduct(response)
                        });
                });

            })();
        }

        function renderRecommendationProduct(res) {
            let resHtml = res.recommendations['search-dropdown-nosto-1'],
                searchWrapper = predictiveSearchResults.querySelector('#predictive-search-results'),
                resultDefault = predictiveSearchResults.querySelector('.results__group-2'),
                rate = Shopify.currency.rate,
                currencyCode = Shopify.currency.active;

            let div = document.createElement('div');
            div.innerHTML = resHtml;

            let data = [];
            let wrapNostoItem = div.getElementsByTagName('nosto-item');

            for (let nItem of wrapNostoItem) {
                let skuItems = nItem.getElementsByTagName('sku-item'),
                    basePriceSku = '-1',
                    showFrom = false;
            
                if (skuItems.length && (nItem.getAttribute('data-price') == nItem.getAttribute('data-listPrice'))) {
                    basePriceSku = Number(nItem.getAttribute('data-price').replace('$', '').replace(',', ''));
                  
                    for (let skuItem of skuItems) {
                        let skuPrice = Number(skuItem.getAttribute('s-data-price').replace('$', '').replace(',', ''))
                      
                        if(skuPrice !== basePriceSku) showFrom = true;
                        if(skuPrice < basePriceSku) basePriceSku = skuPrice;
                    }
                }
              
                data.push({
                    'url': nItem.getAttribute('data-url'),
                    'name': nItem.getAttribute('data-name'),
                    'img': nItem.getAttribute('data-img'),
                    'price': nItem.getAttribute('data-price').replace('$', ''),
                    'brand': nItem.getAttribute('data-brand'),
                    'productId': nItem.getAttribute('data-id'),
                    'basePriceSku': basePriceSku,
                    'showPriceFrom': showFrom,
                    'customFields': nItem.getAttribute('data-customFields'),
                })
            }
            if (!document.querySelector('#predictive-search-products')) {
                console.log('nosto-search-recommadtion', data)
            }

            let html = `
            <div class="results results--products">
             <div class="s-product-list-top"> <h2 class="h2" id="predictive-search-products">Popular Products</h2></div>
               <ul role="listbox" class="r-listbox" aria-labelledby="predictive-search-products">`
            data.forEach(function (item) {
                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: currencyCode,
                    currencyDisplay: 'narrowSymbol'
                });
                let nostoPrice = Number(item.price.replace(/[^0-9\.]+/g, '')),
                    finalPrice = nostoPrice * rate;
                let priceOnDisplay = formatter.format(finalPrice);

                if (item.showPriceFrom) {
                    priceOnDisplay = 'from ' + formatter.format((Number(item.basePriceSku) * rate));
                }
              
                if(item.customFields && item.customFields.includes("custom-show_product_price=true")) {
                  priceOnDisplay = '';
                }
              
                html += `
                         <li role="option" class="r-item">
                            <a href="${item.url}" class="search-nosto-product-item" product-nosto-id="${item.productId}">
                                <div class="results-products__image grid__image-ratio">
                                  <img src="${item.img}" alt="${item.name}">
                              </div>
                              <div class="results-products__info">
                                  <span class="grid-product__vendor">${item.brand}</span>
                                  <span>${item.name}</span>
                                  <span class="grid-product__price">${priceOnDisplay}</span>
                              </div>
                           </a>
                        </li>`;
            });
            html += `
               </ul>
            </div>`;

            resultDefault.innerHTML = html;
            // trigger product click
            let productElements = predictiveSearchResults.querySelectorAll('.search-nosto-product-item');

            productElements.forEach(el => el.addEventListener('click', e => {
                nostojs(api => {
                    api
                        .defaultSession()
                        .recordAttribution("vp", e.currentTarget.getAttribute('product-nosto-id'), "search-dropdown-nosto-1")
                        .done()
                })
            }));

            // insert brand
            let htmlBrand = ``,
                max_item = theme.autocomplete_settings.brand_limit_display,
                total = 0;
            data.forEach(item => {
                let brandUrl = window.location.origin + '/collections/' + item.brand.replace(' ', "-").toLowerCase();
                if (max_item && total >= max_item) {
                    return;
                }
                htmlBrand += `
                    <li role="option" class="r-item">
                      <a href="${brandUrl}">
                        <span>${item.brand}</span>
                      </a>
                    </li>
                    `;
                total++;
            })
            if (htmlBrand) {
                predictiveSearchResults.querySelector('.predictive-search-brands').innerHTML = htmlBrand;
                predictiveSearchResults.querySelector('.results--brands').style.display = 'block';
            }
        }
    }
})();
